(function() {
  'use strict';

  function logDebug(message, data) {
    if (!window.qfTrackingDebug) {
      return;
    }
    if (data) {
      console.log(message, data);
      return;
    }
    console.log(message);
  }

  function resolveTrackingParams(eventName, params) {
    const resolvedParams = params && typeof params === 'object' ? params : {};

    if (eventName === 'filter_price' && Object.keys(resolvedParams).length === 0) {
      const selectedPriceRange = getSelectedPriceRangeValue(document);

      if (selectedPriceRange) {
        return {
          filter_price: normaliseFilterValue(selectedPriceRange)
        };
      }
    }

    return resolvedParams;
  }

  window.qfTrackGa4 = function(eventName, params) {
    if (
      window.Shopify &&
      window.Shopify.customerPrivacy &&
      typeof window.Shopify.customerPrivacy.analyticsAllowed === 'function' &&
      !window.Shopify.customerPrivacy.analyticsAllowed()
    ) {
      logDebug('[qf-tracking] blocked', { event: eventName, params: params || {} });
      return;
    }

    window.dataLayer = window.dataLayer || [];
    const normalisedParams = resolveTrackingParams(eventName, params);
    window.dataLayer.push(
      Object.assign(
        {
          event: eventName,
          params: normalisedParams
        },
        normalisedParams
      )
    );
    logDebug('[qf-tracking] event', { event: eventName, params: params || {} });

    if (typeof window.gtag === 'function') {
      window.gtag('event', eventName, params || {});
    }
  };

  if (window.qfTrackingBound) {
    return;
  }
  window.qfTrackingBound = true;

  function buildPaypalHint(target, event) {
    const hintParts = [];
    const path = typeof event.composedPath === 'function' ? event.composedPath() : [];
    const candidates = [target].concat(path).filter(Boolean);

    for (let i = 0; i < candidates.length && i < 6; i += 1) {
      const node = candidates[i];
      if (!node || node.nodeType !== 1) {
        continue;
      }

      const attrs = [
        node.getAttribute('data-gateway-name'),
        node.getAttribute('aria-label'),
        node.getAttribute('title'),
        node.getAttribute('alt'),
        node.getAttribute('data-testid')
      ];
      hintParts.push(attrs.filter(Boolean).join(' '));
    }

    return hintParts.join(' ').toLowerCase();
  }

  function getAdvancedFilterEventName(themeLabel) {
    const normalizedTheme = String(themeLabel || '').trim().toLowerCase();

    if (!normalizedTheme) return null;
    if (normalizedTheme.includes('artist')) return 'filter_artist';
    if (normalizedTheme === 'type' || normalizedTheme.includes('medium')) return 'filter_medium';
    if (normalizedTheme === 'size' || normalizedTheme.includes('framed size')) return 'filter_framedsize';
    if (normalizedTheme.includes('colour') || normalizedTheme.includes('color')) return 'filter_colour';
    if (normalizedTheme.includes('orientation') || normalizedTheme.includes('style')) return 'filter_orientation';
    if (normalizedTheme.includes('price')) return 'filter_price';

    return null;
  }

  function normaliseFilterValue(value) {
    return String(value || '').trim().toLowerCase();
  }

  function trackFilterEvent(eventName, value) {
    if (!eventName) return;

    const formattedValue = normaliseFilterValue(value);
    if (!formattedValue) return;

    window.qfTrackGa4(eventName, {
      [eventName]: formattedValue
    });
  }

  function parsePriceTextToInt(value) {
    if (value === undefined || value === null) return null;
    const parsed = parseInt(String(value).replace(/[^\d]/g, ''), 10);
    return Number.isNaN(parsed) ? null : parsed;
  }

  function getSelectedPriceRangeValue(scope) {
    const root = scope && scope.querySelector ? scope : document;
    const rangeInputs = root.querySelectorAll('.range-input input');

    if (rangeInputs.length >= 2) {
      const minRange = parseInt(rangeInputs[0].value, 10);
      const maxRange = parseInt(rangeInputs[1].value, 10);

      if (!Number.isNaN(minRange) && !Number.isNaN(maxRange)) {
        const min = Math.min(minRange, maxRange);
        const max = Math.max(minRange, maxRange);
        return `${min}-${max}`;
      }
    }

    const minFallback = root.querySelector('#rangeMin');
    const maxFallback = root.querySelector('#rangeMax');
    const minRange = parseInt(minFallback?.value, 10);
    const maxRange = parseInt(maxFallback?.value, 10);

    if (!Number.isNaN(minRange) && !Number.isNaN(maxRange)) {
      const min = Math.min(minRange, maxRange);
      const max = Math.max(minRange, maxRange);
      return `${min}-${max}`;
    }

    return null;
  }

  function getPriceTrackingScope(target) {
    if (!target || typeof target.closest !== 'function') {
      return document;
    }

    return (
      target.closest('.price-wrapper') ||
      target.closest('#price-container') ||
      target.closest('#ac-filter-wrapper') ||
      document
    );
  }

  function getFacetValueFromLink(linkEl, eventName) {
    const rawLabel = String(linkEl?.textContent || '')
      .replace(/\(\s*\d[\d,]*\s*\)\s*$/, '')
      .trim();

    if (eventName === 'filter_price') {
      const priceParts = rawLabel.split('-').map((part) => part.trim());

      if (priceParts.length >= 2) {
        const minRaw = parsePriceTextToInt(priceParts[0]);
        const maxRaw = parsePriceTextToInt(priceParts[1]);

        if (minRaw !== null && maxRaw !== null) {
          const min = Math.min(minRaw, maxRaw);
          const max = Math.max(minRaw, maxRaw);
          return `${min}-${max}`;
        }
      }

      const ranges = rawLabel
        .match(/\d[\d,]*/g)
        ?.map((num) => parseInt(num.replace(/,/g, ''), 10))
        .filter((num) => !Number.isNaN(num));

      if (ranges && ranges.length >= 2) {
        const min = Math.min(ranges[0], ranges[ranges.length - 1]);
        const max = Math.max(ranges[0], ranges[ranges.length - 1]);
        return `${min}-${max}`;
      }
    }

    return rawLabel;
  }

  document.addEventListener(
    'click',
    function(event) {
      const wishlistTarget = event.target.closest('.smartwishlist, #smartwishlist');
      if (wishlistTarget) {
        window.qfTrackGa4('add_to_wishlist', {
          item_id: wishlistTarget.getAttribute('data-product') || '',
          item_variant: wishlistTarget.getAttribute('data-variant') || ''
        });
        return;
      }

      const galleryPhone = event.target.closest('.gallery-phone');
      if (galleryPhone) {
        window.qfTrackGa4('gallery_phone_click', {
          gallery_title: galleryPhone.getAttribute('data-gallery-title') || '',
          gallery_path: galleryPhone.getAttribute('data-gallery-path') || ''
        });
        return;
      }

      const galleryEmail = event.target.closest('.gallery-email');
      if (galleryEmail) {
        window.qfTrackGa4('gallery_email_click', {
          gallery_title: galleryEmail.getAttribute('data-gallery-title') || '',
          gallery_path: galleryEmail.getAttribute('data-gallery-path') || ''
        });
        return;
      }

      const acFacetLink = event.target.closest('#ac-filter-wrapper .custom-filter .filter-body a[href]');
      if (acFacetLink) {
        const parentFilter = acFacetLink.closest('.custom-filter');
        const headingLabel = parentFilter?.querySelector('.filter-heading-label')?.textContent || '';
        const eventName = getAdvancedFilterEventName(headingLabel);
        const filterValue = getFacetValueFromLink(acFacetLink, eventName);

        trackFilterEvent(eventName, filterValue);
      }

      const acApplyPriceRange = event.target.closest('#applyPriceRange');
      if (acApplyPriceRange) {
        const filterWrapper = getPriceTrackingScope(acApplyPriceRange);
        const selectedPriceRange = getSelectedPriceRangeValue(filterWrapper);

        trackFilterEvent('filter_price', selectedPriceRange);
      }

      const checkoutTarget = event.target.closest(
        'a[href="/checkout"], a[href^="/checkout?"], .checkout-btn, .checkout, button[name="checkout"], input[name="checkout"], .shopify-payment-button__button, [data-testid="checkout-button"]'
      );
      if (checkoutTarget) {
        window.qfTrackGa4('checkout_button_click');
      }

      const paypalTarget = event.target.closest(
        '[data-gateway-name], [aria-label*="paypal" i], [title*="paypal" i], img[alt*="paypal" i], .shopify-payment-button__button'
      );
      if (paypalTarget) {
        const paypalHint = buildPaypalHint(paypalTarget, event);
        if (paypalHint.includes('paypal')) {
          window.qfTrackGa4('checkout_paypal_click');
        }
      }

    },
    true
  );

  document.addEventListener(
    'change',
    function(event) {
      const acFilterSelect = event.target?.closest?.('#ac-filter-wrapper .custom-filter select');
      if (!acFilterSelect) {
        return;
      }

      const parentFilter = acFilterSelect.closest('.custom-filter');
      const headingLabel =
        parentFilter?.querySelector('.filter-heading-label')?.textContent ||
        acFilterSelect.name ||
        acFilterSelect.id ||
        '';

      const eventName = getAdvancedFilterEventName(headingLabel);
      const selectedValue =
        acFilterSelect.value ||
        acFilterSelect.options?.[acFilterSelect.selectedIndex]?.text ||
        '';

      trackFilterEvent(eventName, selectedValue);
    },
    true
  );
})();
